import React from 'react';
import ConfiguratorMenuPage from './ConfiguratorMenuPage.react';
import ConfiguratorSettings from './ConfiguratorSettings.react';
import ConfiguratorAdmin from './ConfiguratorAdmin.react';
import { Tab, Tabs, TabList, TabPanel } from 'react-tabs';
import { FormattedMessage } from 'react-intl';

class ConfiguratorLeftCol extends React.Component {

    constructor(props, context) {
        super(props, context);

        this.handleSelect = this.handleSelect.bind(this);

        this.state = {
            tabIndex: 0
        }
    }

    static get defaultProps() {
        return {
            ConfiguratorManager: {}
        }
    }

    handleSelect(index, last) {

        const newState = {
            ...this.state,
            tabIndex: index,
        };

        this.setState(newState);

        // console.log('Selected tab: ' + index + ', Last tab: ' + last);
    }

    componentDidMount() {

        const steps = [
            {
                title: <FormattedMessage id='TEXT_FEATURE_TOUR_CONFIGURATOR_TITLE_2' />,
                text: <FormattedMessage id='TEXT_FEATURE_TOUR_CONFIGURATOR_MESSAGE_2' />,
                selector: '.menu-page',
                position: 'right',
            }
        ];

        this.props.checkSubcomponentMounted ? this.props.checkSubcomponentMounted() : null;
        this.props.addSteps ? this.props.addSteps(steps) : null;
    }

    render() {

        let { ConfiguratorManager, validatePage } = this.props;

        return (
            <div>
                <Tabs onSelect={this.handleSelect} selectedIndex={this.state.tabIndex}>
                    <TabList>
                        <Tab><div><i className="material-icons">insert_drive_file</i><span><FormattedMessage id="LABEL_PAGES"/></span></div></Tab>
                        <Tab><div><i className="material-icons">settings</i><span><FormattedMessage id="LABEL_SETTINGS"/></span></div></Tab>
                    </TabList>

                    <TabPanel className="menu-page">
                        <ConfiguratorMenuPage
                          ConfiguratorManager={ConfiguratorManager}
                          validatePage={validatePage}
                        />
                    </TabPanel>
                    <TabPanel>
                        <ConfiguratorSettings ConfiguratorManager={ConfiguratorManager} />
                    </TabPanel>

                </Tabs>

                <ConfiguratorAdmin ConfiguratorManager={ConfiguratorManager}  />

            </div>
        );
    }
}

export default ConfiguratorLeftCol;


// WEBPACK FOOTER //
// ./src/js/components/ConfiguratorLeftCol.react.jsx